import { Injectable } from "@angular/core";
import { ApiService } from "@meddatacore/common";
import { CommonFilter } from "../../models";


@Injectable({ providedIn: 'root' })
export class WidgetService extends ApiService {
    endPoint = '/api/widgets';
    getLastAppointments(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/last-appointments`, filter);
    }

    getLastOperations(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/last-operations`, filter);
    }

    getLastIncomes(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/last-incomes`, filter);
    }

    getLastPatients(filter: CommonFilter) {
        return this.http.post<any>(`${this.reportBaseUrl}${this.endPoint}/last-patients`, filter);
    }
}